module.exports = __webpack_public_path__ + "static/media/back_white.2559371e.png";